import React from 'react';
import PropTypes from 'prop-types';

export default function X(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
  );
}

X.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

X.defaultProps = {
  color: '#202020',
  width: 20,
};